/**
 * Подпись кнопки «Продлить» в карточке ученика: с числом дней, а при 0 (запись уже дотягивает до срока) — без
 * числа, а не «Продлить на 0 дней» (техдолг 399).
 *
 * ⚠️ Файл админки, а не `lib/`: ключи `adminDetail.*` в общем помощнике сторож ученических текстов принимает за
 * ученические (`lib/enrollmentActions.ts` импортируют и кураторские экраны).
 */
export function extendButtonLabel(days: number): { key: string; count?: number } {
  return days > 0 ? { key: 'adminDetail.extendDays', count: days } : { key: 'adminDetail.extendAccess' };
}
